<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fa fa-user"></i> Cliente
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                  class="col-md-4 mb-3"
                                  :class="{ 'dropdown-has-error': $v.model.id_pais.$error }"
                              >
                                  <label>País*</label>
                                  <select-api
                                      ref="selectPais"
                                      v-model="model.id_pais"
                                      :endpoint="'/pais/pesquisa'"
                                      :opt-text="'nome'"
                                      :select-option="true"
                                     
                                  ></select-api>
                              </div>
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>
                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.email.$error }"
                                >
                                    <label>E-mail*</label>
                                    <input
                                        type="email"
                                        :readonly="model.id"
                                        maxlength="100"
                                        class="form-control"
                                        v-model="model.email"
                                    />
                                </div>
                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.telefone.$error }"
                                >
                                    <label>Telefone*</label>
                                    <masked-input
                                        v-model.trim="model.telefone"
                                        mask="(11) 11111-1111"
                                        class="form-control"
                                    ></masked-input>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.cpf.$error }"
                                >
                                    <label>CPF*</label>
                                    <masked-input
                                        v-model.trim="model.cpf"
                                        mask="111.111.111-11"
                                        class="form-control"
                                    ></masked-input>
                                </div>
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nascimento.$error }"
                                >
                                    <label>Data de Nascimento*</label>
                                    <input-datepicker
                                        :disabled="false"
                                        :readonly="false"
                                        :group="false"
                                        :autoclose="true"
                                        v-model="model.nascimento"
                                    ></input-datepicker>
                                </div>

                                <div
                                    class="col-md-4"
                                    :class="{ 'dropdown-has-error': $v.model.sexo.$error }"
                                >
                                    <label>Sexo*</label>
                                    <select2
                                        :options="sexos"
                                        v-model="model.sexo"
                                        placeholder="Selecione um sexo"
                                        :select-option="true"
                                    >
                                        <option value selected>Selecione um sexo</option>
                                    </select2>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Código Operadora</label>
                                    <input
                                        type="text"
                                        :readonly="model.id"
                                        maxlength="20"
                                        class="form-control"
                                        v-model="model.codigoOperadora"
                                    />
                                </div>
                                <div class="col-md-4">
                                    <label>Data de Criação*</label>
                                    <input-datepicker
                                        :disabled="true"
                                        :readonly="true"
                                        :group="false"
                                        :autoclose="true"
                                        v-model="model.criado_em"
                                    ></input-datepicker>
                                </div>
                                <div class="col-md-4">
                                    <label>Ativo</label>
                                    <input-toggle v-model="model.ativo" :value="model.ativo"></input-toggle>
                                </div>
                            </div>
                        </div>
                    </div>

                    <dw-form-address v-if="model.endereco != null && pais" :pais="pais" :id_pais="model.id_pais" v-bind:model="model.endereco" ref="formAddress"></dw-form-address>

                    <div class="card">
                        <div class="card-footer text-right">
                            <router-link :to="{ name: 'list-client' }" class="btn btn-link">Cancelar</router-link>
                            <router-link
                                v-if="model.id"
                                :to="{ name: 'new-pet', params:{idCliente:model.id}}"
                                class="btn btn-secondary"
                            >Adicionar Pet</router-link>
                            <router-link
                                v-if="model.id"
                                :to="{ name: 'list-pet', params:{idCliente:model.id}}"
                                class="btn btn-secondary"
                            >Ver Pet</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";

const facade = new Facade();

import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isUndefinedOrNullOrEmpty,
    isNotUndefinedOrNullOrEmptyOrZero,
    formatPhone,
    formatCpf,
    formatCep,
    clearCpfCnpj
} from "@/services/string";
import { isPhone, isCpf, validateCPF } from "@/services/util";
import Collections from "../../helpers/collections";
import SelectApi from "../../components/Input/SelectApi";
import Select2 from '../../components/Input/Select2';
export default {
    components: {
      SelectApi, Select2
    },
    data() {
        return {
            pais: null,
            model: {
                nome: "",
                email: "",
                telefone: "",
                cpf: "",
                sexo: "",
                id_pais: 0,
                codigoOperadora: '',
                nascimento: moment().format("YYYY-MM-DD"),
                criado_em: moment().format("YYYY-MM-DD"),
                ativo: true,
                endereco: {
                    logradouro: "",
                    numero: "",
                    complemento: "",
                    bairro: "",
                    id_estado: "0",
                    id_cidade: "0",
                    cep: ""
                }
            },
            sexos: []
        };
    },
    validations() {
        return {
            model: {
                nome: {
                    required,
                    minLength: minLength(2)
                },
                email: {
                    required,
                    email,
                    minLength: minLength(5)
                },
                telefone: {
                    required,
                    isPhone
                },
                nascimento: {
                    required
                },
                sexo: {
                    required
                },
                cpf: {
                    required,
                    validateCPF,
                    isCpf
                },
                id_pais: {
                    required
                }
            }
        };
    },
    methods: {
        save() {
            let vm = this;
            
            if (this.$v.model.$invalid || this.$refs.formAddress.isInvalid()) {
                this.$v.model.$touch();
                this.$refs.formAddress.isInvalid();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);
            
            if (vm.model.id) {
                let ret = facade.updateClient(vm.model);
                ret.then(client => {
                    this.$router.push({ name: "list-client" });
                    this.$loading.show(false);
                }).catch(e => {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            } else {
                
                let ret = facade.createClient(vm.model);
                ret.then(client => {
                    this.$router.push({ name: "list-client" });
                    this.$loading.show(false);
                }).catch(e => {
                    e.forEach(item => {
                        this.$notify.error(item.field, item.message);
                    });
                    this.$loading.show(false);
                });
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(client) {
            if (client !== undefined && client !== null) {
                client.telefone = client.telefone
                    ? formatPhone(client.telefone)
                    : "";
                client.cpf = client.cpf ? formatCpf(client.cpf) : "";
                this.model = client;
            }
            this.sexos = Collections.sexos;
        }
    },
    watch: {
        'model.id_pais': function () {
            switch(this.$refs.selectPais.model){
                case "1": 
                    this.pais = {codigo: "BR"};
                    break;
                case "2":
                    this.pais = {codigo: "MX"};
                    break;
                case "3":
                    this.pais = {codigo: "CL"};
                    break;    
            }
        },
      
    },
    beforeRouteEnter(to, from, next) {
        const vm = this;
  
        Promise.all([to.params.id ? facade.getClient(to.params.id) : null])
            .then(response => {
                next(vm =>
                    vm.setData(
                        response[0] != null ? response[0].data.data : null
                    )
                );
            })
            .catch(e => {
                next(vm => vm.setData());
            });
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?501691a4